import { Col, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import './ReconciliationTATReport.less';
import UploadFileAlert from '../UploadFileAlert';
import { ReconciliationReportList } from './ReconciliationReportList';
import { canActivate } from '../../../utils/utility';
import ReconciliationDashboard from './ReconciliationDashboard';
const ReconcilationTurnaroundTime = (): ReactElement => {
  const [isAlertModalVisible, setIsAlertModalVisible] = useState(false);
  const [updatedClaimNumbersCount, setUpdatedClaimNumbersCount] = useState(0);
  const [totalClaimCount, setTotalClaimCount] = useState(0);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const editReconciliation = canActivate(authFeatureConstants.EDIT_RECONCILIATION);

  const onButtonClickHandler = (): void => {
    setIsAlertModalVisible(false);
    setIsSuccess(false);
  };

  const successHandler = (
    claimCount: number = 0,
    totalCount: number = 0,
  ): void => {
    setUpdatedClaimNumbersCount(claimCount);
    setTotalClaimCount(totalCount);
    setIsSuccess(true);
  };
  const closeModal = (): void => {
    setIsModalOpen(false);
  };
  return (<>
    <div className="reconciliation">
      <div className="tab-custom-container">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16} className="custom-ant-tab">
            {editReconciliation && (
              <>
                {isAlertModalVisible &&
                  <UploadFileAlert
                    isVisible={isAlertModalVisible}
                    onButtonClick={onButtonClickHandler}
                    onSuccess={successHandler}
                    isSuccess={isSuccess}
                    updatedClaimNumbersCount={updatedClaimNumbersCount}
                    totalClaimCount={totalClaimCount}
                  />
                }
              </>
            )}
          </Col>
          <Col md={8}>
            {isModalOpen &&
              <ReconciliationReportList isModalOpen={isModalOpen} closeModal={closeModal} />
            }
          </Col>
        </Row>
      </div>
      <div className="reconciliation-dashboard">
        <ReconciliationDashboard dashboardType="ReconciliationTAT" />
      </div>
    </div>
  </>
  );
};

export default ReconcilationTurnaroundTime;
